import Model from '@/lib/data/Model';

class SharedEntity extends Model {
    static idProperty = 'id';

    editing = false;

    success = false;

    translationEdit = null;

    fields = [
        'id',
        'entity_id',
        'entity_type',
        'token',
        'expiration_date_utc',
        'organization_id',
        'shared_by',
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'validate',
            url: '/validate_shared',
            params: ['id', 'token'],
        },
        {
            name: 'shareEntity',
            url: '/share_entity',
            params: ['entity_id', 'entity_type', 'organization_id', 'shared_by'],
        },
        {
            name: 'sendSharedInfo',
            url: '/send_share_entity',
            params: ['id', 'entity_id', 'token', 'notification_type', 'to'],
        },
        {
            name: 'saveSectionVisibility',
            url: '/set_sections_visibility_in_shared_mode',
            params: ['id', 'entity_id', 'visible_sections'],
        },
        {
            name: 'stopSharing',
            url: '/stop_share',
            params: ['entity_id', 'id'],
        },
    ];
}

export default SharedEntity;
